"use strict";

var Label, React;

React = require("react");

Label = React.createClass({
  displayName: "Label",

  propTypes: {
    onClick: React.PropTypes.func,
    item: React.PropTypes.object
  },
  onClick: function onClick(e) {
    return this.props.onClick(this.props.item);
  },
  render: function render() {
    return React.createElement(
      "span",
      { className: "tm-tag tm-tag-info" },
      React.createElement(
        "span",
        null,
        this.props.item.displayName
      ),
      React.createElement(
        "a",
        { className: "tm-tag-remove", onClick: this.onClick },
        "x"
      )
    );
  }
});

module.exports = Label;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/TypeAhead/Label.js
 ** module id = 575
 ** module chunks = 0
 **/